import { atom, useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { useInterval } from "react-use";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Modal } from "@/components/ui/modal";
import { Text } from "@/components/ui/text";
import { logout } from "../api";

const timeoutWarningAtom = atom(false);

export function useSetTimeoutWarning() {
  return useAtom(timeoutWarningAtom);
}

function Countdown() {
  const [count, setCount] = useState(60);

  useInterval(
    () => {
      setCount((c) => c - 1);
    },
    count <= 0 ? null : 1000,
  );

  useEffect(() => {
    if (count <= 0) {
      logout(true);
    }
  }, [count]);

  return (
    <Text>You will be automatically signed out after {count} seconds.</Text>
  );
}

export function TimeoutWarningDialog() {
  const titleRef = useRef<string>(document.title);
  const [open, setOpen] = useAtom(timeoutWarningAtom);

  useEffect(() => {
    if (open) {
      titleRef.current = document.title;
      document.title = "Still there?";
    } else {
      document.title = titleRef.current;
    }
  }, [open]);

  return (
    <Modal isOpen={open} onOpenChange={setOpen}>
      <Dialog>
        <DialogHeader>
          <DialogTitle>Do you want to stay signed in?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Countdown />
        </DialogBody>
        <DialogFooter>
          <DialogCloseButton variant="default">Yes</DialogCloseButton>
          <Button variant="outline" onPress={() => logout()}>
            No
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
